import * as angular from 'angular';
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.agent-inventory')
  .factory('AgentInventoryAPI', AgentInventoryAPI);

function AgentInventoryAPI(): BringozApi {
  return {
    base: `/agentInventory`,
    infiniteScroll: {
      address: `/agentInventory`,
      cmd: 'GET'
    },
    actions: {
      getTransactions: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      createLoadTransaction: {
        address: 'load',
        cmd: 'PUT',
        updateable: false
      },
      createUnloadTransaction: {
        address: 'unload',
        cmd: 'PUT',
        updateable: false
      }
    }
  }
}

